import { apiLoyaltyActions } from './apiLoyaltyActions'
import { apiLoyaltyActivities } from './apiLoyaltyActivities'
import { apiLoyaltyPoints } from './apiLoyaltyPoints'
import { apiLoyaltyRules } from './apiLoyaltyRules'
import { apiLoyaltyTransation } from './apiLoyaltyTransation'

const apiPointsGroup = {
	...apiLoyaltyRules,
	...apiLoyaltyActions,
	...apiLoyaltyActivities,
	...apiLoyaltyTransation,
	...apiLoyaltyPoints,
}

export { apiPointsGroup }
